import React from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import { connect } from "react-redux";

const options = [
  { value: "chocolate", label: "Chocolate" },
  { value: "strawberry", label: "Strawberry" },
  { value: "vanilla", label: "Vanilla" },
];

function SMSelect(props) {
  let data = props.data ?? options;
  const customStyles = {
    control: (styles) => ({
      ...styles,
      backgroundColor: props.themes !== "light" ? "#e4e7eb" : "#4b5563",
      color: "white",
      borderColor: props.themes !== "light" ? "white" : "#4b5563",
    }),
    value: (styles) => ({
      ...styles,
      color: "white",
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isDisabled ? "red" : "#4b5563",
        color: "#FFF",
        cursor: isDisabled ? "not-allowed" : "default",
      };
    },
  };

  return (
    <Select
      options={data}
      defaultValue={props.defaultValue}
      styles={customStyles}
      className="w-full"
      onChange={(e) => props.onChange(e)}
    />
  );
}

SMSelect.propTypes = {
  data: PropTypes.array,
  defaultValue: PropTypes.object,
  onChange: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    themes: state.darkmode.theme,
  };
};

export default connect(mapStateToProps)(SMSelect);
